import {
  CA_DELETE_ASSIGNATION_BEGIN,
  CA_DELETE_ASSIGNATION_SUCCESS,
  CA_DELETE_ASSIGNATION_FAILURE,
  CA_DELETE_ASSIGNATION_DISMISS_ERROR,
} from './constants';


import{ SERVER_PATH,AXIOS_CONFIG } from '../../common/redux/constantes';
import axios from 'axios';

let tableRef = null;


// Rekit uses redux-thunk for async actions by default: https://github.com/gaearon/redux-thunk
// If you prefer redux-saga, you can use rekit-plugin-redux-saga: https://github.com/supnate/rekit-plugin-redux-saga
export function deleteAssignation(_tableRef, assignationID,args = {}) {
  tableRef = _tableRef;
  return (dispatch) => { // optionally you can have getState as the second argument
    dispatch({
      type: CA_DELETE_ASSIGNATION_BEGIN,
    });

    // Return a promise so that you could control UI flow without states in the store.
    // For example: after submit a form, you need to redirect the page to another when succeeds or show some errors message if fails.
    // It's hard to use state to manage it, but returning a promise allows you to easily achieve it.
    // e.g.: handleSubmit() { this.props.actions.submitForm(data).then(()=> {}).catch(() => {}); }
    const promise = new Promise((resolve, reject) => {
      // doRequest is a placeholder Promise. You should replace it with your own logic.
      // See the real-word example at:  https://github.com/supnate/rekit/blob/master/src/features/home/redux/fetchRedditReactjsList.js
      // args.error here is only for test coverage purpose.
      axios.post(SERVER_PATH + '/deliverable_assignations/edit', {
        deliverable_assignation:{
        "assignation":assignationID+'',
        "status":"0"
        }
      }, AXIOS_CONFIG())
      .then(
        (res) => {
          dispatch({
            type: CA_DELETE_ASSIGNATION_SUCCESS,
            data: res,
          });
          resolve(res);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          dispatch({
            type: CA_DELETE_ASSIGNATION_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissDeleteAssignationError() {
  return {
    type: CA_DELETE_ASSIGNATION_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case CA_DELETE_ASSIGNATION_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        deleteAssignationPending: true,
        deleteAssignationError: null,
      };

    case CA_DELETE_ASSIGNATION_SUCCESS:
      // The request is success
      tableRef.current && tableRef.current.onQueryChange();
      return {
        ...state,
        deleteAssignationPending: false,
        deleteAssignationError: null,
      };

    case CA_DELETE_ASSIGNATION_FAILURE:
      // The request is failed
      return {
        ...state,
        deleteAssignationPending: false,
        deleteAssignationError: action.data.error,
      };

    case CA_DELETE_ASSIGNATION_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        deleteAssignationError: null,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/ca/redux/deleteAssignation.js